export const MAXLENGTH = 40;
export const SIZE = { SM: 'sm' };
export const VARIANT = { PRIMARY: 'primary' };

export const CREATE_LIST_MODAL_FIELDS = {
  LIST_NAME: 'folName' as const,
  LIST_TYPE: 'listType' as const,
  FILE_NAME: 'fileName' as const,
  EQUIPMENT: 'equipment' as const
};

export const OPEN_BUTTON_TEXT = 'SL_CREATE_LIST';
export const FILE_SIZE_LIMIT = 75;

export const EXTENSION_FILES = ['csv', 'xlsx'];
export const DEFAULT_EQUIPMENT_VALUE = {
  key: '',
  value: {
    assetName: '',
    model: '',
    serialNumber: ''
  }
};
